import React from 'react';

import { PRODUCT_TOUR } from '../tours';
import { useTourGuide } from '../TourGuideProvider';

export function TourLauncher({ tourId = PRODUCT_TOUR.id }: { tourId?: string }) {
  const tour = useTourGuide();

  if (!tour) return null;

  const completed = Boolean(tour.progress[tourId]);
  const running = tour.run.running;

  return (
    <button
      type="button"
      className="tour-guide-launcher tour-guide-launcher--tour"
      data-testid="quick-tour-button"
      data-completed={completed ? '' : undefined}
      aria-label={completed ? 'Replay the guided product tour' : 'Start the guided product tour'}
      disabled={running}
      onClick={() => tour.start(tourId)}
    >
      <svg
        className="tour-guide-launcher__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
      <span className="tour-guide-launcher__label">Quick Tour</span>
    </button>
  );
}
